import { Component, OnInit } from '@angular/core';
import { Departure} from '../../../_models/departure';
import { Inventory} from '../../../_models/inventory_loc';
import { Zone} from '../../../_models/zone';
import { OptiData } from '../../../_models/opti_data';
import { OptiPiece } from '../../../_models/opti_piece';
import * as fromOpti from '../../../opti/state/opti.reducer';
import * as optiActions from '../../../opti/state/opti.actions';
import * as fromRoot from '../../../state/app.reducer';
import * as rootActions from '../../../state/app.actions';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';


@Component({
  templateUrl: './opti-edit-shell.component.html'
})

export class OptiEditShellComponent implements OnInit {

    optiList$: Observable<OptiData[]>;
    retalList$: Observable<OptiPiece[]>;
    currentOpti$: Observable<OptiData>;
    lastRemnant$: Observable<number>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromOpti.State>
  ) {}

  ngOnInit() {

    this.optiList$ = this.store.pipe(select(fromOpti.getOptiList)) as Observable<OptiData[]>;
    this.currentOpti$ = this.store.pipe(select(fromOpti.getCurrentOpti)) as Observable<OptiData>;
    this.retalList$ = this.store.pipe(select(fromOpti.getRetalOptiList)) as Observable<OptiPiece[]>;
    
    // NOTA: todas estas cargas de datos dispararán al inicio la correspondiente
    // función "onChange" de los ".ts". Esto lo hace antes de ejecutar cualquier dispatch anterior,
    // lo que quiere decir que si el dispatch cambia unas de estas variables entonces volverá
    // a disparar la función "onChange" nuevamente una segunda vez, que será donde aparecerá
    // ahora ya sí disponible el valor de la variable cambiado por el dispatch.
  }

  getUserNameZones(params: { user_id: number, group_id: number, lager: string }): void {

    // Se cargan los nombres de las zonas permitidas al usuario logueado.
    console.log('**-> getUserNameZones nombres zonas del usuario: '
    + params.user_id + ' ;grupo: ' + params.group_id + ' ;lager: ' + params.lager);

    // this.store.dispatch( new optiActions.LoadNameZones({ user_id: params.user_id, group_id: params.group_id, lager: params.lager }));
    // this.store.dispatch( new optiActions.LoadZones({lager: params.lager }));

  } // End function getUserZones

  getSizes(params: { breite: number, hoehe: number, material: string, lager: string}): void {

    console.log('**-> getSizes disponibles: ' + 'Anchura:' + params.breite + ' ;Altura: ' + params.hoehe);

    // tslint:disable-next-line:max-line-length
    // this.store.dispatch( new optiActions.LoadSizes({ breite: params.breite, hoehe: params.hoehe, material: params.material, lager: params.lager}));

  } // End function getSizes

  // NOTA: Las funciones realmente deberían quedar con una simple instrucción "dispatch".
  saveOpti(optiIn: any): void {

    console.log('---> saveOpti optiIn:');
    console.log(optiIn);

    this.store.dispatch( new optiActions.RegisterOpti(optiIn));
  }

  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando movement-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal

} // End class MovementEditShellComponent
